<template>
  <v-container>
    <v-snackbar v-model="snackbar" :color="color.snackbar" top="top">
      {{ message }}
      <v-btn dark text @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <v-card-title>Service</v-card-title>

    <v-row>
      <v-col cols="12" sm="3" v-for="item in listVmFix" :key="item.id">
        <v-card >
          <div class="text-center pt-2"><b>{{item.name}}</b></div>
          <div class="text-center"><b>{{item.vm}}</b></div>
          <br>
          <v-row>
            <v-col cols="12" sm="6">
              <center>
                <round-slider
                  class="mx-2"
                  v-model="item.percent_mem"
                  start-angle="315"
                  end-angle="+270"
                  line-cap="round"
                  read-only="true"
                  radius="45"
                  :tooltip-format="tooltipVal2"
                  width="10"
                  rangeColor="#c90000"
                />
              </center>
            </v-col>
            <v-col cols="12" sm="6">
              <center>
                <round-slider
                  class="mx-2"
                  v-model="item.percent_storage"
                  start-angle="315"
                  end-angle="+270"
                  line-cap="round"
                  read-only="true"
                  radius="45"
                  :tooltip-format="tooltipVal2"
                  width="10"
                  rangeColor="orange"
                />
              </center>
            </v-col>
          </v-row>
          <div class="d-flex">
            <v-icon x-large color="#c90000">mdi-circle-small</v-icon>
            <div class="mt-2">Memory : {{item.used_mem}} / {{ item.total_mem }}</div>
          </div>
          <div class="d-flex">
            <v-icon x-large color="orange">mdi-circle-small</v-icon>
            <div class="mt-2">Storage : {{item.used_storage}} / {{item.total_storage}}</div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <br><br>

    <v-card>
      <v-row class="mx-2">
        <v-col cols="12" sm="8">
          <v-text-field
            solo
            label="Cari"
            v-model="cariService"
            clearable
            prepend-inner-icon="search"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-btn
            class="white--text"
            color="#c90000"
            large
            @click="restartAllService()"
          >
            <v-icon>mdi-rotate-3d-variant </v-icon> Restart semua service</v-btn
          >
        </v-col>
      </v-row>
      <v-card>
        <v-data-table
          show-select
          v-model="selected"
          :headers="headers"
          :search="cariService"
          :items="listService"
          hide-default-footer
          :items-per-page="150"
          class="elevation-1"
        >
          <template v-slot:[`item.port`]="{ item }">
            <div>{{ item.ip }} : {{ item.port }}</div>
          </template>
          <template v-slot:[`item.on_terakhir`]="{ item }">
            <div>{{ item.on_terakhir | dateTimeFormat}}</div>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <div v-if="item.status == true" style="color: #c90000">Aktif</div>
            <div v-else style="color: red">Tidak Aktif</div>
          </template>
          <template v-slot:[`item.auto_nyala`]="{ item }">
            <v-switch
              v-model="item.auto_on"
              input-value="true"
              color="#c90000"
              @change="autoNyala(item)"
            ></v-switch>
          </template>
          
          <template v-slot:[`item.restart`]="{ item }">
            <div>
              <v-btn
                @click="restartService(item)"
                color="#c90000"
                small
                outlined
              >
                <v-icon>mdi-rotate-3d-variant </v-icon> Restart</v-btn
              >
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-card>
    <br><br><br>
    <v-card
      style="position: fixed; bottom: 0;z-index:100"
      class="py-1"
      width="100%"
      elevation="5"
    >
      <v-row class="mx-4">
        <v-spacer></v-spacer>

        <v-col cols="12" sm="4">
          <div class="d-flex pt-2">
            <div class="pt-1">{{ selected.length }} Service Terpilih</div>
            <v-spacer></v-spacer>

            <div>
              <v-select
                outlined
                :items="action"
                dense
                label="Ubah Service"
                v-model="dataAction"
                single-line
                @change="postAction()"
              ></v-select>
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="4">
          <v-btn
            @click="restServiceSelected()"
            class="mt-2"
            color="#c90000"
            outlined
            >Restart</v-btn
          >
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="dialogService" persistent max-width="400px">
      <v-card rounded="lg">
        <v-card-title>
          Apakah Anda ingin mengaktifkan auto nyala pada service ini?
        </v-card-title>
        <v-card-actions style="margin-right: 2%">
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn outlined color="#c90000">Tidak </v-btn>
          <v-btn color="#c90000" class="white--text"> Ya </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import RoundSlider from 'vue-round-slider'
import moment from 'moment-timezone';
export default {
  name: 'Service',
  data: () => ({
    listService: [],
    sliderValue: 50,
    color: { snackbar: '' },
    snackbar: false,
    message: null,
    listVm: [],
    cariService:'',
    listVmFix: [],
    selected: [],
    headers: [
      {
        text: 'Nama Service',
        value: 'modul',
      },
      { text: 'Aktivitas Terakhir', value: 'on_terakhir' },
      { text: 'VM', value: 'port' },
      { text: 'Kondisi', value: 'status' },
      { text: 'Aksi', value: 'restart' },
      { text: 'Sistem Cek Terakhir', value: 'cek_status_terakhir' },
      { text: 'Auto Nyala', value: 'auto_nyala' },
    ],
    action: ['Aktifkan', 'Non Aktifkan'],
    dataAction: '',
    dialogService: false,
  }),
  components: {
    RoundSlider,
  },
  methods: {
    async getListService() {
      await this.$req
        .get(this.$root.$baseapi.monitoring+'/monitoring/v1/list_service')
        .then((response) => {
          this.listService = response.data.data;
          console.log('list service', this.listService);
        })
        .catch((error) => {
          let responses = error.response.data;
          console.log(responses.api_message);
        });
    },
    async restartService(item) {
      let formData = new FormData();
      formData.append('id', item.id);

      this.$req.post(this.$root.$baseapi.monitoring+'/monitoring/v1/restart_service', formData)
      .then((response) => {
        this.snackbar = true;
        this.message = response.data.api_message;
        this.color.snackbar = 'success';
      }).catch((error) => {
        let responses = error.response.data;
        this.snackbar = true;
        this.message = responses.data.api_message;
        this.color.snackbar = 'error';
      });
    },
    async restServiceSelected() {
      let formData = new FormData();
      for (let i = 0; i < this.selected.length; i++) {
        formData.append('id', this.selected[i].id);
      }
      this.$req
        .post(this.$root.$baseapi.monitoring+'/monitoring/v1/restart_service', formData)
        .then((response) => {
          this.snackbar = true;
          this.message = response.data.api_message;
          this.color.snackbar = 'success';
        })
        .catch((error) => {
          let responses = error.response.data;
          this.snackbar = true;
          this.message = responses.data.api_message;
          this.color.snackbar = 'error';
        });
    },
    async restartAllService() {
      this.$req
        .post(this.$root.$baseapi.monitoring+'/monitoring/v1/restart_all_service')
        .then((response) => {
          this.snackbar = true;
          this.message = response.data.api_message;
          this.color.snackbar = 'success';
        })
        .catch((error) => {
          let responses = error.response.data;
          this.snackbar = true;
          this.message = responses.data.api_message;
          this.color.snackbar = 'error';
        });
    },
    async postAction() {
      if (this.dataAction == 'Aktifkan') {
        let formData = new FormData();
        for (let i = 0; i < this.selected.length; i++) {
          formData.append('id', this.selected[i].id);
        }
        this.$req
          .post(this.$root.$baseapi.monitoring+'/monitoring/v1/on_service', formData)
          .then((response) => {
            this.snackbar = true;
            this.message = response.data.api_message;
            this.color.snackbar = 'success';
          })
          .catch((error) => {
            let responses = error.response.data;
            this.snackbar = true;
            this.message = responses.data.api_message;
            this.color.snackbar = 'error';
          });
      } else {
        let formData = new FormData();
        for (let i = 0; i < this.selected.length; i++) {
          formData.append('id', this.selected[i].id);
        }
        this.$req
          .post(this.$root.$baseapi.monitoring+'/monitoring/v1/off_service', formData)
          .then((response) => {
            this.snackbar = true;
            this.message = response.data.api_message;
            this.color.snackbar = 'success';
          })
          .catch((error) => {
            let responses = error.response.data;
            this.snackbar = true;
            this.message = responses.data.api_message;
            this.color.snackbar = 'error';
          });
      }
    },
    async getVm(){
      await this.$req
        .get(this.$root.$baseapi.monitoring+'/monitoring/v1/list_vm')
        .then((response) => {
          this.listVm = response.data.data;
          for (let i = 0; i < this.listVm.length; i++) {
            this.listVmFix.push(
              {
                id:this.listVm[i].id,
                name:this.listVm[i].name,
                vm:this.listVm[i].vm,
                used_mem:this.listVm[i].used_mem,
                used_storage:this.listVm[i].used_storage,
                free_mem:this.listVm[i].free_mem,
                free_storage:this.listVm[i].free_storage,
                total_mem:this.listVm[i].total_mem,
                total_storage:this.listVm[i].total_storage,
                percent_mem:Math.round(this.listVm[i].percent_mem),
                percent_storage:Math.round(this.listVm[i].percent_storage)
              }
            )
          }
          
          console.log('list listVm', this.listVm);
          console.log('list listVmFix', this.listVmFix);
        })
        .catch((error) => {
          let responses = error.response.data;
          console.log(responses.api_message);
        });
    },
    async autoNyala(data){
      let formData = new FormData();
      formData.append('id', data.id);
      formData.append('auto_on', data.auto_on);
      
      this.$req.post(this.$root.$baseapi.monitoring+'/monitoring/v1/auto_start', formData)
      .then((response) => {
        this.snackbar = true;
        this.message = response.data.api_message;
        this.color.snackbar = 'success';
      }).catch((error) => {
          let responses = error.response.data;
          this.snackbar = true;
          this.message = responses.data.api_message;
          this.color.snackbar = 'error';
      });
    },
    tooltipVal2(args) {
      return args.value + "%";
    }
  },
  async created() {
    this.getListService();
    this.getVm();
  },
  filters: {
        countDoc(doc) {
        if (doc !== null) {
            return true;
        }
        },
        datediff: date => {
        return moment(date).from();
        },
        dateFormat: date => {
        return moment.utc(date).format('DD MMM YYYY');
        },
        timeFormat: date => {
        return moment.utc(date).format('HH:mm');
        },
        dateTimeFormat: date => {
        return moment.utc(date).format('DD MMM YYYY HH:mm');
        }
    },
};
</script>

<style>
</style>
